const {Component} = require("react");
const PropTypes = require("prop-types");
const env = require("app/services/env");
const RestrictedInput = require("app/components/fields/RestrictedInput");
const Trans = require('app/components/trans/Trans')
const { numberFormat } = require('app/util/formaters');

class RibbonSelector extends Component {

	static get propTypes() {
		return {
			option: PropTypes.any,
			texts: PropTypes.any,
			onChange: PropTypes.func
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			option: props.option || "none",
			texts: props.texts && (props.texts instanceof Array) ? props.texts : []
		};

		// Transform ribbons to a more accessible format
		this.ribbons = {};

		env.get("checkout.ribbons", []).forEach(ribbon => {
			this.ribbons[ribbon.id] = ribbon;
		});
	}

	getRibbonPlaceholder(index) {
		const ribbonIndex = Math.round((index + 1) / 2);
		const lineIndex = (index + 1) % 2 === 0 ? 2 : 1;

		return translate('Tekst på bånd :ribbonIndex, linje :lineIndex', {'ribbonIndex': ribbonIndex, 'lineIndex': lineIndex });
	}

	normalizeMessages(messages, length) {
		if (messages.length > length) {
			return messages.slice(0, length);
		}

		if (messages.length < length) {
			for (let i = messages.length; i < length; i++) {
				messages.push("");
			}
		}

		return messages;
	}

	get value() {
		if (this.state.option === "none") {
			return;
		}

		return {
			id: this.state.option,
			messages: this.state.texts
		};
	}

	get options() {
		let options = [];

        let zeroPrice = numberFormat(0, true);

		// Placeholder
		options.push({
            title: translate('Intet bånd (:price)', {price: zeroPrice}),
			value: "none"
		});

		// Add the rest of the ribbons
		Object.keys(this.ribbons).forEach(ribbonId => {
			options.push({
				title: this.ribbons[ribbonId].title,
				value: ribbonId
			});
		});

		return options;
	}

	get current() {
		if (this.state.option === "none") {
			return;
		}

		return this.ribbons[this.state.option];
	}

	reset() {
		this.selectElement.value = "none";

		this.setState({
			option: "none",
			texts: []
		});
	}

	onChange() {
		if (typeof this.props.onChange === "function") {
			return this.props.onChange(this.value);
		}
	}

	_onOptionChange = (e) => {
		const ribbonId = e.target.value;
		const placeholders = ribbonId === "none" ? 0 : this.ribbons[ribbonId].ends * 2;

		this.setState({
			option: ribbonId,
			texts: this.normalizeMessages(this.state.texts, placeholders)
		});

		this.onChange();
	};

	_inputChangeListener = (index) => {
		return (e) => {
			const value = e.target.value;

			this.setState(state => {
				state.texts[index] = value;
				return state;
			});

			this.onChange();
		};
	};

	renderInputs() {
		const placeholders = this.current.ends * 2;
		let inputs = [];
		let text;

		for (let i = 0; i < placeholders; i++) {
			text = this.state.texts[i] || "";

			inputs.push(
				<RestrictedInput maxLength={40} key={i} onInput={this._inputChangeListener(i)} type="text" defaultValue={text}
												 placeholder={this.getRibbonPlaceholder(i)}/>
			);
		}

		return inputs;
	}


	renderInputBody() {
		const current = this.current;

		if (!current || (current.placeholders === 0)) {
			return;
		}

		return (
			<div className="text-inputs">{this.renderInputs()}</div>
		);
	}

	renderOptions() {
		return this.options.map(ribbon => {
			return <option key={ribbon.value} value={ribbon.value}>{ribbon.title}</option>
		});
	}

	renderSelector() {
		return (
			<select ref={el => this.selectElement = el} id="ribbonSelector" onChange={this._onOptionChange}
							defaultValue={this.state.option}>{this.renderOptions()}</select>
		);
	}

	render() {
		return (
			<div className="ribbon-widget">
				<label htmlFor="ribbonSelector"><Trans>Vælg båndtype og -tekst</Trans></label>
				{this.renderSelector()}
				{this.renderInputBody()}
			</div>
		);
	}

}

module.exports = RibbonSelector;
